module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 162.5f10ecf4.png";